import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'

// Firebase config con fallback seguro para evitar build con env vacio
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyARHomp_bADJ5KK1YMe9ioR7UDxi65zoYg',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'calculoprevisional-c5785.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'calculoprevisional-c5785',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'calculoprevisional-c5785.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '599472213121',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:599472213121:web:2320e18ef5a9d70d04d180',
}

// Inicializar Firebase
const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)

// Inicializar Firestore con cache settings (alternativa nueva a enableIndexedDbPersistence)
let db

try {
  // Usar nueva API de cache si está disponible
  db = initializeFirestore(app, {
    cache: persistentLocalCache({
      tabManager: persistentMultipleTabManager()
    })
  })
} catch (error) {
  // Fallback: usar getFirestore si ya fue inicializado
  db = getFirestore(app)
}

export { db }
export const functions = getFunctions(app, 'us-central1')
